import './BottomRecommendationPanel.css';
import React from 'react';
import BottomShadowOverlay from '../atoms/BottomShadowOverlay/BottomShadowOverlay';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import BottomPanelModal from '../atoms/BottomPanelModal/BottomPanelModal';
import PanelMenu from './PanelMenu/PanelMenu';
import { useOnKeyPress } from '../../utils/hooks/useOnKeyPress';
var BottomRecommendationPanel = function BottomRecommendationPanel(_ref) {
  var items = _ref.items,
    title = _ref.title,
    titleSvg = _ref.titleSvg,
    _hide = _ref.hide;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  useOnKeyPress(["Esc", "Escape"], function () {
    return _hide();
  });
  return /*#__PURE__*/React.createElement(BottomShadowOverlay, null, /*#__PURE__*/React.createElement(BottomPanelModal, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    rtl: rtl,
    title: title,
    svgIcon: titleSvg,
    hide: function hide() {
      return _hide(true);
    }
  }, /*#__PURE__*/React.createElement(PanelMenu, {
    rtl: rtl,
    items: items
  })));
};
export default BottomRecommendationPanel;
var PANE_SHIFT = '180px';
var MIDDLE_OR_SHIFT_SCREEN_SIZE = '1065px';
var commonStyles = "cqcie0p";
var rtlStyles = "r2iscpz";
var ltrStyles = "l1o10884";